"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCartHasInvalidBundles = void 0;
// hash of bundle dependencies, example: { [bundleId]: [productId1, productId2] }
const isCartHasInvalidBundles = (lineItems, hash) => {
    if (!lineItems.length || !Object.keys(hash).length)
        return false;
    const cartBundlesHash = lineItems.reduce((acc, lineItem) => {
        if (lineItem.bundleId) {
            acc[lineItem.bundleId] = [...(acc[lineItem.bundleId] || []), lineItem.productId];
        }
        return acc;
    }, {});
    return Object.keys(cartBundlesHash).some(cartBundleId => JSON.stringify(cartBundlesHash[cartBundleId].sort()) !== JSON.stringify(hash[cartBundleId].sort()));
};
exports.isCartHasInvalidBundles = isCartHasInvalidBundles;
exports.default = exports.isCartHasInvalidBundles;
//# sourceMappingURL=isCartHasInvalidBundles.js.map